export const SKUPrefixes = {
  GOLD: [
    "GDCH",
    "GDLSH",
    "GDLBBBR",
    "GDLHE",
    "GDLBBPD",
    "GDTEST",
    "GDBR",
    "GDLBBNP",
    "GDLBBR",
    "GDLBBER",
    "GDLBBNE",
    "GDLBBMN",
    "GDCO",
    "GDLBR",
    "GDLPD",
    "GDLNE",
    "GDPD",
    "GDNE",
    "GDMN",
    "GDER",
    "GDR",
    "GDLER",
    "GDLMN",
    "GDLNP",
    "GDLR",
    "GDMT",
  ],
  SILVER: [
    "PU",
    "HP",
    "LT",
    "CDPD",
    "VPTR",
    "SDER",
    "SDR",
    "SDPD",
    "MT",
    "VPSH",
    "VPBL",
    "SDLR",
    "EX",
    "TEST",
    "SDLER",
    "MI_",
    "JO",
    "BH",
    "WC",
    "VPJA",
    "GC",
    "FREEGIFT",
    "CF",
    "GW",
    "PL",
    "TP",
    "SDLPD",
    "CO",
    "BCH",
    "CHEM",
    "PR",
    "PFSET",
    "VDGPD",
    "VDGNE",
    "VDGMN",
    "VDGBR",
    "VDGCH",
    "VDSPD",
    "VDSNE",
    "VDSMN",
    "VDSER",
    "VDSR",
    "VDSBR",
    "VDSCH",
    "CA",
    "VDGER",
    "VDGR",
    "NE",
    "PF",
    "PER",
    "ID",
    "UT",
    "KER",
    "KR",
    "CR",
    "PX",
    "NP",
    "HA0",
    "VP",
    "VDSGR",
    "VDSGBR",
    "VDSGPD",
    "VDSGMN",
    "VDSGNE",
    "VDSGER",
    "KBR",
    "KPD",
    "RK",
    "AV",
    "TR",
    "CH",
    "PM",
    "FER",
    "MER",
    "FI",
    "KA",
    "ER",
    "A",
    "PD",
    "BR",
    "BB",
    "R",
  ],
  ONNME: [
    "OMR",
    "OMPD",
    "OMA",
    "OMWC",
    "OMPH",
    "OMBR",
    "OMNE",
    "OMCH",
    "OMHA",
    "OMER",
  ],
};

export const isOnnmeSkuPrefix = (code) =>
  SKUPrefixes.ONNME.some((prefix) => code === prefix || code.startsWith(prefix));
